export default {"src":"/_next/static/media/moongate-icon.f01d560d.svg","height":30,"width":31};